import { render, staticRenderFns } from "./ChooseExamNumberOfExercisesModalComponent.vue?vue&type=template&id=9459c86c&scoped=true&"
import script from "./ChooseExamNumberOfExercisesModalComponent.vue?vue&type=script&lang=js&"
export * from "./ChooseExamNumberOfExercisesModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChooseExamNumberOfExercisesModalComponent.vue?vue&type=style&index=0&id=9459c86c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9459c86c",
  null
  
)

export default component.exports